export default function savePlaceEditsFactory(ajax, getSession) {
  return async function savePlaceEdits({ id, data }) {
    return ajax({ resource: `places/localities/${id}`, method: 'patch', data });
  };
}



// WEBPACK FOOTER //
// ./src/services/savePlaceEdits.js